var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1467_18086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41065 2.01552L0.808079 8.61856C0.774861 8.65188 0.750876 8.69395 0.739455 8.73916L0.00762279 11.6766C-0.0142684 11.765 0.0117155 11.859 0.0762469 11.9236C0.125074 11.9724 0.191604 11.9994 0.259657 11.9994C0.280501 11.9994 0.301821 11.9969 0.32257 11.9916L3.25999 11.2597C3.30577 11.2483 3.34736 11.2244 3.38058 11.1912L9.98372 4.58859L7.41065 2.01552Z",
    fill: "#3179C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6198 1.11522L10.8848 0.380245C10.3936 -0.110975 9.53743 -0.110499 9.04678 0.380245L8.14648 1.28054L10.7195 3.85352L11.6198 2.95322C11.8651 2.70794 12.0003 2.38148 12.0003 2.03427C12.0003 1.68705 11.8651 1.36059 11.6198 1.11522Z",
    fill: "#3179C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1467_18086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.de9027b3c79bdd20cdd2041bb1be2459.svg";
export { ForwardRef as ReactComponent };